/**
 * NovaAuthLayoutRoute: the sign-in page in Nova's look (mist background, orb, a clean card), without the site shell.
 * Only /auth/login uses it; the other auth pages keep the standard auth shell.
 */
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@bloomneo/uikit';
import '@/features/nova/nova.css';
import { Watermark } from '@/features/nova/components/Watermark';

function ThemeButton() {
  const { mode, setMode } = useTheme();
  const dark = mode === 'dark';
  return (
    <div className="icons">
      <button className="icon" aria-label={dark ? 'Switch to light' : 'Switch to dark'} title="Light or dark" onClick={() => setMode(dark ? 'light' : 'dark')}>
        {dark
          ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
          : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>}
      </button>
    </div>
  );
}

export function NovaAuthLayoutRoute() {
  // reveal the page (see the boot style in index.html) once the scene has painted
  React.useEffect(() => {
    const id = requestAnimationFrame(() => (window as unknown as { __nvReady?: () => void }).__nvReady?.());
    return () => cancelAnimationFrame(id);
  }, []);
  return (
    <div className="nv auth">
      <div className="mist" aria-hidden="true" />
      <Watermark />
      <ThemeButton />
      <Outlet />
    </div>
  );
}
